/* eslint-disable react/prop-types */
import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import { get, omit } from 'lodash';
import WithApplePay from './WithApplePay';


const checkQueryString = BaseComponent => (props) => {
  const withApplePay = !!get(props, 'location.query.applePay');
  if (withApplePay && !props.hasApplePay) {
    props.router.replace({ ...props.location, query: omit(location.query, 'applePay') });
    return null;
  }
  return <BaseComponent {...props} withApplePay={withApplePay} />;
};

export default compose(
  withRouter,
  WithApplePay,
  checkQueryString
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithApplePayQuery.jsx